import { Box, Typography } from "@mui/material";

import { useCustomColors } from "../hooks/useCustomColors";

interface BrandLogoProps {
  height?: number | Record<string, number>;
  onClick?: () => void;
}

const scale = (
  height: number | Record<string, number>,
  factor: number
): number | Record<string, number> =>
  typeof height === "number"
    ? Math.round(height * factor)
    : Object.fromEntries(
        Object.entries(height).map(([key, value]) => [
          key,
          Math.round(value * factor),
        ])
      );

const BrandLogo = ({ height = 44, onClick }: BrandLogoProps) => {
  const colors = useCustomColors();

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        cursor: onClick ? "pointer" : "default",
      }}
    >
      <Box
        component="img"
        src="/favicon.svg"
        alt="eclwin88"
        sx={{ height, width: height, display: "block", flexShrink: 0 }}
      />
      <Typography
        component="span"
        sx={{
          fontWeight: 700,
          lineHeight: 1,
          letterSpacing: "0.01em",
          fontSize: scale(height, 0.46),
          background: `linear-gradient(120deg, ${colors.accent.goldBright}, ${colors.accent.gold}, ${colors.accent.goldSoft})`,
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          color: "transparent",
        }}
      >
        eclwin88
      </Typography>
    </Box>
  );
};

export default BrandLogo;
